import React, { Component } from 'react'
import './style.css'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
export default class gallery extends Component {
    state={
        photoIndex: 0,
        isOpen: false,
    }
    lightBoxToggle=(i)=>{
        this.setState({photoIndex:i,isOpen:!this.state.isOpen})
    }
    render() {
        const { photoIndex, isOpen } = this.state;
        const {image}=this.props
        return (
            <div>
                <div className='grid-gallery-wrapper'>
                    {this.props.image.map((img,i)=>(
                        <div className='image-gallery-overlay' onClick={()=>this.lightBoxToggle(i)}>
                            <img src={img.img}/>
                            <div className='image-gallery-caption hidden-mobile'>
                                <h6 >{img.title}</h6>
                                <br/>
                                <p>{img.caption}</p>
                            </div>
                            <div className='image-gallery-caption-mobile show-mobile hidden-desktop'>
                                <h6 >{img.title}</h6>
                                {/* <br/> */}
                                {/* <p>{img.caption}</p> */}
                            </div>
                        </div>
                    ))}
                    
                </div>
                {isOpen && (
                    <Lightbox
                        mainSrc={image[photoIndex].img}
                        // nextSrc={image[(photoIndex + 1) % image.length].img}
                        // prevSrc={image[(photoIndex + image.length - 1) % image.length].img}
                        imageCaption={image[photoIndex].caption}
                        // mainSrcThumbnail={image[photoIndex].caption}
                        // mainSrcThumbnail={image[(photoIndex + 1) % image.length].caption}
                        // nextSrcThumbnail={image[(photoIndex + image.length - 1) % image.length].caption}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + image.length - 1) % image.length,
                        })
                        }
                        onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % image.length,
                        })
                        }
                    />
                )}
            </div>
        )
    }
}
